import { createTheme } from '@mui/material/styles';

import components from './components';
import palette from './palette';
import typography from './typography';

const theme = createTheme({
  palette,
  components,
  typography,
  spacing: 4,
  shape: {
    borderRadius: 1,
  },
});

export default theme;
